import {Component, Input} from '@angular/core';
import {NgIf} from "@angular/common";
import {RouterLinkActive} from "@angular/router";

@Component({
  selector: 'app-sidebar-button',
  imports: [
    NgIf,
    RouterLinkActive
  ],
  templateUrl: './sidebar-button.component.html',
  styleUrl: './sidebar-button.component.scss'
})
export class SidebarButtonComponent {
  @Input() title: string = "";
  @Input() subtitle: string = "";
}
